module.exports = __webpack_public_path__ + "img/eematico-toys-kit-de-construire.7046be6e.jpg";